import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
Vue.use(Vuex)

const isProd = process.env.VUE_APP_ENV === 'production'

// Data Paths
const configData = isProd ? '/data/config.json' : process.env.VUE_APP_API_HOST + '/config'
const navigationData = isProd ? '/data/navigation.json' : process.env.VUE_APP_API_HOST + '/navigation'
const pagesData = isProd ? '/data/pages.json' : process.env.VUE_APP_API_HOST + '/pages'
const livingOptionsData = isProd ? '/data/living-options.json' : process.env.VUE_APP_API_HOST + '/living/living-options'
const subsectionsData = isProd ? '/data/subsections.json' : process.env.VUE_APP_API_HOST + '/living/subsections/touch'
const propertiesData = isProd ? '/data/properties.json' : process.env.VUE_APP_API_HOST + '/living/properties/touch'
const propertyModelsData = isProd ? '/data/property-models.json' : process.env.VUE_APP_API_HOST + '/living/property-models'

// Store Modules
import favourites from './favourites.module'
import property from './property.module'
import sidebar from './sidebar.module'

export default new Vuex.Store({
  modules: {
    favourites,
    property,
    sidebar,
  },

  state: {
    assetsPath: isProd ? '/assets/' : process.env.VUE_APP_ASSETS_HOST,
    version: process.env.VUE_APP_VERSION,
    deviceName: null,
    selector: null,

    config: null,
    navigation: [],
    pages: [],

    isBottomBarVisible: false,
    triggerVideos: false,
    hideLiveHere: false,
    appScale: 1,

    language: { code: 'en', rtl: false },
    languages: [
      {name: 'English', code: 'en', rtl: false},
      {name: 'العربية', code: 'ar', rtl: true}
    ]
  },

  getters: {
    activeNavigation (state, getters) {
      let activeNavigationItem = null
      if (state.route.params.categoryId) {
        activeNavigationItem =  _.find(getters.navigation, category => {
          return category._id === state.route.params.categoryId
        })
      } else {
        getters.navigation.forEach(category => {
          if (state.route.path.includes(category.customRoute)) {
            activeNavigationItem = category
          }
        })
      }
      return activeNavigationItem && activeNavigationItem.children ? activeNavigationItem.children : null
    },

    activePage (state) {
      let activePage = null
      if (state.route.params.pageId) {
        activePage = _.find(state.pages, page => {
          return page._id === state.route.params.pageId
        })
      }
      return activePage
    },

    activeSubNavigation (state, getters) {
      let activeSubNavigation = null
      if (getters.activeNavigation && getters.activePage) {
        const activePageId = getters.activePage._id
        getters.activeNavigation.forEach(parentNavigationItem => {
          if (parentNavigationItem.pageId === activePageId) {
            activeSubNavigation = parentNavigationItem.children
          }
          if (parentNavigationItem.children) {
            parentNavigationItem.children.forEach(childNavigationItem => {
              if (childNavigationItem.pageId === activePageId) {
                activeSubNavigation = parentNavigationItem.children
              }
            })
          }
        })
      }
      return activeSubNavigation
    },

    navigation (state) {
      let navigation = JSON.parse(JSON.stringify(state.navigation))
      if (navigation && navigation.length) {
        navigation.forEach(navigationCategory => {
          navigationCategory.children = _.sortBy(navigationCategory.children, child => child.order)
        })
      }
      return navigation
    },

    language (state) {
      return state.language
    },

    languages (state) {
      return state.languages
    }
  },

  mutations: {
    SET_CONFIG (state, config) {
      state.config = config
    },

    SET_NAVIGATION (state, navigation) {
      state.navigation = navigation
    },

    SET_PAGES (state, pages) {
      state.pages = pages
    },
    
    SET_LANGUAGE (state, language) {
      state.language = language
    }
  },

  actions: {
    fetchData ({ commit }) {
      return Promise.all([
        axios.get(configData).then(res => {
          const configItems = res.data.config.items
          let configObject = {}
          configItems.map(el => {
            configObject[el.key] = el.value
          })
          commit('SET_CONFIG', configObject)
        }).catch(err => {
          console.warn(err)
        }),

        axios.get(navigationData).then(res => {
          commit('SET_NAVIGATION', res.data.categories)
        }).catch(err => {
          console.warn(err)
        }),

        axios.get(pagesData).then(res => {
          commit('SET_PAGES', res.data)
        }).catch(err => {
          console.warn(err)
        }),

        axios.get(livingOptionsData).then(res => {
          commit('property/SET_LIVING_OPTIONS', res.data)
        }).catch(err => {
          console.warn(err)
        }),

        axios.get(subsectionsData).then(res => {
          commit('property/SET_SUBSECTIONS', res.data)
        }).catch(err => {
          console.warn(err)
        }), 
        
        axios.get(propertiesData).then(res => {
          commit('property/SET_PROPERTIES', res.data)
        }).catch(err => {
          console.warn(err)
        }),   
        
        axios.get(propertyModelsData).then(res => {
          commit('property/SET_PROPERTY_MODELS', res.data)
        }).catch(err => {
          console.warn(err)
        })
      ]) 
    },

    snitch ({ state }) {
      axios.get(`https://snitch.sensoreal.com.au/touch-seen/${state.deviceName}`).catch(e => {
        console.error(e)
      })
    },

    toggleBottomBarVisibility ({ state }) {
      // TODO: dispatch a mutation that sets the bar as visible
      state.isBottomBarVisible = !state.isBottomBarVisible
    },

    triggerVideo ({ state }, videoWallTrigger) {
      if (state.triggerVideos && state.videoWallHost && videoWallTrigger) {
        console.log(`GET ${state.videoWallHost}/play/${videoWallTrigger}`)
        axios.get(`http://${state.videoWallHost}/play/${videoWallTrigger}`)
          .then(function (response) {
            console.log(response)
          })
          .catch(function (error) {
            console.log(error);
          })
      }
    }
  }
})
